'use strict';

/*global services*/

(function ($) {
  $.extend({
    k2_copyClipboard: function (data) {
      var _this = this;

      var $textArea = $('<textarea>');

      $textArea.css({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '2em',
        height: '2em',
        padding: 0,
        border: 'none',
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
        zIndex: 10000
      }).val(data);

      var modal = services.get('modal');
      if (modal && modal.isOpen()) {
        $textArea.appendTo(modal.contentDOM());
      } else {
        $textArea.appendTo('body');
      }

      $textArea[0].select();
      services.get('notifications').viewCopyMessage();
      try {
        if (document.execCommand('copy')) {
          services.get('notifications').viewCopyMessage();
        } else {
          services.get('notifications').viewErrorMessage();
        }
      } catch (e) {
        if (e) {
          services.get('notifications').viewErrorMessage();
        }

        services.get('notifications').viewErrorMessage();
      }

      $textArea.remove();

      return _this;
    }
  });
})(jQuery);
